import styled from "styled-components";

import KnightImg from "./img/2nd/knight.gif"
import PriestImg from "./img/2nd/priest.gif"
import WizzardImg from "./img/2nd/wizzard.gif"
import SmithImg from "./img/2nd/smith.gif"
import HunterImg  from "./img/2nd/hunter.gif"
import KillerImg  from "./img/2nd/killer.gif"

import TemplarImg from "./img/2nd/templar.gif"
import MonkImg from "./img/2nd/monk.gif"
import SageImg from "./img/2nd/sage.gif"
import MercenaryImg from "./img/2nd/mercenary.gif"
import AlchemistImg from "./img/2nd/alchemist.gif"
import BardImg  from "./img/2nd/bard.gif"
import DancerImg  from "./img/2nd/dancer.gif"

function SecondClassQuests() {
    return(<>
        <ClassListContainer>
            <TitleContainer>Classes 2 - 1</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={KnightImg}/>
                <ClassListDescription>Cavaleiro </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={PriestImg}/>
                <ClassListDescription>Sacerdote </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={WizzardImg}/>
                <ClassListDescription>Bruxo </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SmithImg}/>
                <ClassListDescription>Ferreiro </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={HunterImg}/>
                <ClassListDescription>Caçador </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={KillerImg}/>
                <ClassListDescription>Assassino </ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

        <ClassListContainer>
            <TitleContainer>Classes 2 - 2</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={TemplarImg}/>
                <ClassListDescription>Templário </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MonkImg}/>
                <ClassListDescription>Monge</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SageImg}/>
                <ClassListDescription>Sábio </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MercenaryImg}/>
                <ClassListDescription>Mercenário </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={AlchemistImg}/>
                <ClassListDescription>Alquimista </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={BardImg}/>
                <ClassListDescription>Bardo </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={DancerImg}/>
                <ClassListDescription>Dançarina </ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

    </>
    )
}

const TitleContainer = styled.h1`

`

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

     &:hover {
        background-color: rgba(63, 121, 179, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default SecondClassQuests;